import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceProductComponent } from './marketplace-product.component';
import { VaProductDetailsV2Module } from '../product-details-v2/product-details-v2.module';

@NgModule({
  declarations: [MarketplaceProductComponent],
  imports: [CommonModule, VaProductDetailsV2Module],
  exports: [MarketplaceProductComponent],
})
export class MarketplaceProductModule {}
